import React from 'react';
import {connect} from 'react-redux';
import { List, Button, Tooltip, message} from 'antd';
import { AdmsRepository, AdmsAsset } from '../../redux';
import { LoadingComponent } from '../../utils/ui';
import Description from '../widgets/Description';
import i18n from "i18next";

const count = 3;
  
//  см. https://ant.design/components/list/
class AssetRepository extends React.Component {

  constructor(props, context) {
    super(props, context)
    this.state = {
      loading: false, 			//Флаг загрузки
    }
    this.onSelectedInList = this.onSelectedInList.bind(this);
  }
  
  componentDidMount() {
    const {assets, state} = this.props;
    if (state=="empty")
      this.onLoadMore();
  }

  //вызывается только в случае передачи компоненту новых свойств
	//единственный метод ЖЦ компоненты, в котором может быть вызван метод setState;
	componentWillReceiveProps(nextProps){
    const {state, conditions} = nextProps;
    if (state=="empty") //if (!assets || !Array.isArray(assets) || (assets.length<1))
      this.onLoadMore(true, conditions);
  }

  componentWillUpdate(nextProps, nextState) {
    //console.log("componentWillReceiveProps", nextProps, this.state);
	}
    
  onSelectedInList (IRI, item) {
    //console.log("AssetRepository.js onSelectedInList (IRI)", IRI, this);
    const {onSelected, history} = this.props;
    if (onSelected) 
      onSelected(IRI, AdmsAsset, history, item); //onSelected(IRI, AdmsAsset, history, ModelViews);
  }

  /** Метод начального считывания, когда offset=0. Разница в получении количества записей */
  loadFirst = (filter=null) => {
    const {conditions} = this.props;
    this.props.dispatch(AdmsRepository.loadAssets((filter)?filter:conditions))
      .then ((response) =>{
        //console.log("loadFirst = (filter=null) => {", response);
        this.setState({loading: false,}, () => { window.dispatchEvent(new Event('resize')); });
      })
      .catch(e => { 
        message.error(`Ошибка получения данных. ${e}`);
        this.setState({loading: false})
      });
  }
  /** Метод для досчитывания данных */
  onLoadMore = (reload=false, filter=null) => {
    //console.log("onLoadMore", reload, filter, this);
    this.setState({ loading: true });
    const {assets, conditions} = this.props;
    const offset = (!reload && assets && Array.isArray(assets))?assets.length:0;
    if (offset==0){
      this.loadFirst(filter);
      return;
    }
    this.props.dispatch(AdmsRepository.loadNextAssets(offset, (filter)?filter:conditions))
      .then ((response) =>{
        this.setState({
          loading: false,
        }, () => {
          // Resetting window's offsetTop so as to display react-virtualized demo underfloor.
          // In real scene, you can using public method of react-virtualized:
          // https://stackoverflow.com/questions/46700726/how-to-use-public-method-updateposition-of-react-virtualized
          window.dispatchEvent(new Event('resize'));
        });
      })
      .catch(e => { 
        message.error(`Ошибка получения данных. ${e}`);
        this.setState({loading: false})
      });
    }
  
    render() {
      const { loading  } = this.state;
      const { assets, count } = this.props;
      const loadMore = loading ? (
        <div style={{textAlign: 'center', marginTop: 12, height: 32, lineHeight: '32px'}}><LoadingComponent /></div>
      ) : (
        ((assets.length != count) && (count>0))?
        <div style={{textAlign: 'center', marginTop: 12, height: 32, lineHeight: '32px', display1: 'none'}}>
          <Tooltip placement="top" title= {i18n.t('components.adms.repository_tooltip', {count: count, length:count-assets.length})}>
            <Button onClick={() => this.onLoadMore()}>{i18n.t('components.adms.repository_load_next')}</Button>
          </Tooltip>
        </div>
        : null
      );
      console.log(this); //console.log(loading); console.log(loadMore); console.log(JSON.stringify(assets));
      return (
        <List
          className="demo-loadmore-list adms_category_div csi_spoiler active"
          loading={loading}
          itemLayout="horizontal"
          loadMore={loadMore}
          dataSource={assets}
          renderItem={item => (
            <List.Item actions={[]} style={{padding: 0}} onClick={()=> this.onSelectedInList(item.IRI.value, item) }>
              <div className="adms_asset_meta" style={{width: "100%"}}>
                <h3>{(item.dsn)?item.dsn.value:""} <small>{(item.dsv)?"("+item.dsv.value+")":""}</small></h3> 
                <p><Description IRI={item.IRI.value} description={item.description}/></p>
              </div>
            </List.Item>
          )}
        />
      );
    }
  }
  
  function mapStateToProps(state, props) {
    return {
        ...state.vadms
    };
  }
  
  export default connect(mapStateToProps)(AssetRepository);